import { initial_filter_hotels } from "utils";

const FILTER_KEY = "safra_hotels_filter_v1";
const ORDER_KEY = "safra_hotels_order_v1";

const logStorageError = (action, error) => {
    if (process.env.NODE_ENV !== "production") {
        console.error(`[safraHotelsSearchState] ${action}`, error);
    }
};

const hasValidFilterShape = (value) => {
    return Boolean(
        value &&
        typeof value === "object" &&
        value.filterParameters &&
        typeof value.filterParameters === "object" &&
        value.filterParameters.price
    );
};

export const getSafraHotelsFilter = () => {
    try {
        const storedValue = sessionStorage.getItem(FILTER_KEY);
        if (!storedValue) {
            return initial_filter_hotels;
        }

        const parsedValue = JSON.parse(storedValue);
        return hasValidFilterShape(parsedValue) ? parsedValue : initial_filter_hotels;
    } catch (error) {
        logStorageError("Failed to read hotels filter from sessionStorage", error);
        return initial_filter_hotels;
    }
};

export const setSafraHotelsFilter = (filter) => {
    try {
        if (!hasValidFilterShape(filter)) {
            return false;
        }

        sessionStorage.setItem(FILTER_KEY, JSON.stringify(filter));
        return true;
    } catch (error) {
        logStorageError("Failed to write hotels filter to sessionStorage", error);
        return false;
    }
};

export const getSafraHotelsOrder = () => {
    try {
        return sessionStorage.getItem(ORDER_KEY) || "";
    } catch (error) {
        logStorageError("Failed to read hotels order from sessionStorage", error);
        return "";
    }
};

export const setSafraHotelsOrder = (order = "") => {
    try {
        sessionStorage.setItem(ORDER_KEY, order || "");
        return true;
    } catch (error) {
        logStorageError("Failed to write hotels order to sessionStorage", error);
        return false;
    }
};
